import React from 'react';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import GroupsIcon from '@mui/icons-material/Groups';
import GavelIcon from '@mui/icons-material/Gavel';
import NightShelterIcon from '@mui/icons-material/NightShelter';
import AssessmentIcon from '@mui/icons-material/Assessment';

export type ImpactoFinanceiro = 'alto' | 'medio' | 'complementar';

export interface EixoGroup {
  key: string;
  label: string;
  descricao: string;
  icon: React.ComponentType<any>;
  color: string;
  eixos: string[];
  defaultExpanded: boolean;
  impactoFinanceiro: ImpactoFinanceiro;
}

export const EIXO_GROUPS: EixoGroup[] = [
  {
    key: 'esf-eap',
    label: 'eSF / eAP',
    descricao: 'Equipes de Saude da Familia e Atencao Primaria',
    icon: LocalHospitalIcon,
    color: '#1565c0',
    eixos: [
      'c1-mais-acesso',
      'c2-criancas',
      'c3-gestantes',
      'c4-diabeticos',
      'c5-hipertensos',
      'c6-idosos',
      'c7-mulheres',
    ],
    defaultExpanded: true,
    impactoFinanceiro: 'alto',
  },
  {
    key: 'esb',
    label: 'eSB',
    descricao: 'Equipe de Saude Bucal',
    icon: MedicalServicesIcon,
    color: '#00838f',
    eixos: ['odonto'],
    defaultExpanded: false,
    impactoFinanceiro: 'medio',
  },
  {
    key: 'emulti',
    label: 'eMulti',
    descricao: 'Equipe Multiprofissional',
    icon: GroupsIcon,
    color: '#6a1b9a',
    eixos: ['emulti'],
    defaultExpanded: false,
    impactoFinanceiro: 'medio',
  },
  {
    key: 'eapp',
    label: 'eAPP',
    descricao: 'Equipe de Atencao Primaria Prisional',
    icon: GavelIcon,
    color: '#e65100',
    eixos: [
      'eapp-acesso',
      'eapp-gestacao',
      'eapp-diabetes-has',
      'eapp-ist',
      'eapp-cancer',
      'eapp-tuberculose',
    ],
    defaultExpanded: false,
    impactoFinanceiro: 'complementar',
  },
  {
    key: 'ecr',
    label: 'eCR',
    descricao: 'Equipe de Consultorio na Rua',
    icon: NightShelterIcon,
    color: '#2e7d32',
    eixos: [
      'ecr-acesso',
      'ecr-gestacao',
      'ecr-ist',
      'ecr-tuberculose',
    ],
    defaultExpanded: false,
    impactoFinanceiro: 'complementar',
  },
  {
    key: 'complementares',
    label: 'Complementares',
    descricao: 'Producao e Vinculo Territorial',
    icon: AssessmentIcon,
    color: '#757575',
    eixos: ['producao', 'nt30-vinculo'],
    defaultExpanded: false,
    impactoFinanceiro: 'complementar',
  },
];
